module.exports = __webpack_public_path__ + "images/ai_recommendations/door_open-edf984762310bb45fde7e58edad8a2bf.svg";